import { LinearLoader } from '@src/components/shared/LinearLoader';
import { ReactNode } from 'react';

import { useSettingsQuery } from './settingQuery.generated';
import { getSettingContextDefaultValue, SettingsContext } from './SettingsContext';

export function SettingProvider({ children }: { children: ReactNode }) {
    const { data, loading } = useSettingsQuery();

    // Hold rendering until settings have loaded so children never read placeholder
    // defaults (e.g. the post-login default-route redirect resolving before settings arrive).
    if (loading) {
        return <LinearLoader />;
    }

    return (
        <SettingsContext.Provider value={data?.settings ?? getSettingContextDefaultValue()}>
            {children}
        </SettingsContext.Provider>
    );
}
